var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _g3, _g4, _path8, _path9, _path10, _g5, _g6, _g7, _path11, _g8, _path12, _path13, _g9, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAvail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 200,
    viewBox: "0 0 260 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.952 9H17V180H229.952V9Z",
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.949 58.0293H170.723V171.745H229.949V58.0293Z",
    fill: "#000001"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0048 27.2867C36.0462 27.2867 37.7011 25.7587 37.7011 23.8738C37.7011 21.9889 36.0462 20.4609 34.0048 20.4609C31.9635 20.4609 30.3086 21.9889 30.3086 23.8738C30.3086 25.7587 31.9635 27.2867 34.0048 27.2867Z",
    fill: "#24285B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0009 27.2867C47.0423 27.2867 48.6972 25.7587 48.6972 23.8738C48.6972 21.9889 47.0423 20.4609 45.0009 20.4609C42.9595 20.4609 41.3047 21.9889 41.3047 23.8738C41.3047 25.7587 42.9595 27.2867 45.0009 27.2867Z",
    fill: "#0D9F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3564 27.2867C57.3978 27.2867 59.0526 25.7587 59.0526 23.8738C59.0526 21.9889 57.3978 20.4609 55.3564 20.4609C53.315 20.4609 51.6602 21.9889 51.6602 23.8738C51.6602 25.7587 53.315 27.2867 55.3564 27.2867Z",
    fill: "#FFD200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.806 50.5918H46.293V77.8787H132.806V50.5918Z",
    fill: "#A5A5A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2686 73.3447C71.7176 73.3447 76.1348 69.2661 76.1348 64.2348C76.1348 59.2036 71.7176 55.125 66.2686 55.125C60.8196 55.125 56.4023 59.2036 56.4023 64.2348C56.4023 69.2661 60.8196 73.3447 66.2686 73.3447Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.777 58.1816H84.8281V62.7126H117.777V58.1816Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.773 65.7539H84.8242V70.2849H117.773V65.7539Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.59 124.271H97.8906V160.21H138.59V124.271Z",
    fill: "#A5A5A5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5154 124.271H46.8164V160.21H87.5154V124.271Z",
    fill: "#A5A5A5"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.358 20.4609H170.001C167.612 20.4609 165.676 22.2476 165.676 24.4515C165.676 26.6554 167.612 28.442 170.001 28.442H213.358C215.746 28.442 217.683 26.6554 217.683 24.4515C217.683 22.2476 215.746 20.4609 213.358 20.4609Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.999 46.4922H151.207V160.208H243.999V46.4922Z",
    fill: "#24285B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.014 55.123H160.035V80.3548H195.014V55.123Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.182 55.123H200.203V80.3548H235.182V55.123Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.006 85.6094H160.027V110.841H195.006V85.6094Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.182 85.6094H200.203V110.841H235.182V85.6094Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.125 122.115H181.09V135.538H214.125V122.115Z",
    fill: "#FFD200"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.892 123.99H195.562V127.446H209.892V123.99Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.505 141.527H187.887V145.526H209.505V141.527Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6289 84.2109H46.6289V108.09H77.6289V84.2109Z",
    fill: "#0D9F3F"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8594 104.389L57.2461 92.2227L62.4127 101.231L68.6923 93.5857L74.9719 104.389H49.8594Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.558 93.1222C64.9147 93.1222 66.0145 92.1067 66.0145 90.8541C66.0145 89.6014 64.9147 88.5859 63.558 88.5859C62.2014 88.5859 61.1016 89.6014 61.1016 90.8541C61.1016 92.1067 62.2014 93.1222 63.558 93.1222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvail);
export default __webpack_public_path__ + "static/media/not-avail.4b53654ecbe8791d7a344cef91a19853.svg";
export { ForwardRef as ReactComponent };